export enum KeycloakActionType {
  Login = "login",
  Logout = "logout",
  Register = "register",
  Return = "return",

}
